var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"hococo-download-button"}},[(false)?_c('a',{class:_vm.buttonClasses,on:{"click":function($event){return _vm.downloadPdf()}}},[_c('i',{staticClass:"far fa-download"})]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }